import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { Field } from "./AuthShell";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Choose a new password" subtitle="Enter a new password for your account."
      footer={<Link to="/login" className="text-[#1D4ED8] font-semibold">← Back to sign in</Link>}>
      {!token ? (
        <div className="p-5 rounded-xl bg-rose-50 border border-rose-200 text-rose-800">This reset link is invalid. Please request a new one.</div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="New password" data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          <button data-testid="reset-submit" disabled={loading} className="w-full py-3 rounded-full bg-[#1D4ED8] text-white font-semibold hover:bg-[#1E40AF] transition-colors disabled:opacity-60">
            {loading ? "Resetting…" : "Reset Password"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
